import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const issueTransferOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/transfer-orders/:id/issue',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/transfer-orders/:id/issue' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const issueTransferOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 1,
        'number': 'TO-00001',
        'status': 'Issued',
        'type': 'Ship',
        'fromLocationGroup': {
            'id': 1,
            'name': 'Main Warehouse'
        },
        'toLocationGroup': {
            'id': 2,
            'name': 'East Warehouse'
        },
        'carrier': {
            'id': 5,
            'name': 'USPS',
            'service': {
                'id': 3,
                'name': 'Priority Mail'
            }
        },
        'shipFromAddress': {
            'name': 'Main Warehouse',
            'street': '100 Main St',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84101',
            'country': 'UNITED STATES'
        },
        'shipToAddress': {
            'name': 'East Warehouse',
            'street': '200 East Blvd',
            'city': 'Denver',
            'state': 'CO',
            'postalCode': '80201',
            'country': 'UNITED STATES'
        },
        'note': '',
        'ownerIsFrom': true,
        'revisionNumber': 1,
        'lastModified': {
            'username': 'admin',
            'dateLastModified': '2024-03-02T08:00:00.000-0700'
        },
        'dateCreated': '2024-03-01T08:00:00.000-0700',
        'dateIssued': '2024-03-02T08:00:00.000-0700',
        'dateScheduled': '2024-03-05T00:00:00.000-0700',
        'toItems': [
            {
                'id': 101,
                'part': {
                    'id': 28,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Send'
                },
                'status': 'Entered',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'note': '',
                'quantity': '10',
                'quantityFulfilled': '0',
                'quantityPicked': '0',
                'unitCost': '12.50',
                'dateScheduled': '2024-03-05T00:00:00.000-0700'
            }
        ],
        'customFields': []
    },
};

const data: RequestDefinitionData = {
    id: 'issue-transfer-order',
    title: 'Issue a transfer order',
    description: 'Transitions a transfer order from Entered status to Issued. ' +
        'Issuing a transfer order triggers pick creation. ' +
        'Returns 404 if the transfer order is not found.',
    endpoint: {
        verb: 'POST',
        path: '/transfer-orders/:id/issue',
        tooltip: 'Issue a transfer order',
    },
    attributes: [],
    requestObject: issueTransferOrderRequest,
    responseObject: issueTransferOrderResponse,
};

export default data;